import apiST from '../../services/service_shotstorage'
import apiItem from '../../services/service_item'
var moment = require('moment')

export default {
  data () {
    return {
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      search: '',
      bill_list: [],
      currentPage: 1,
      len_list: 0,
      list_group: [],
      group_code: '',
      data_modal: {
        'id': 0,
        'company_id': 1,
        'branch_id': 0,
        'doc_no': '',
        'doc_date': moment(new Date()),
        'accept_date': '',
        'description': '',
        'accept_status': 0,
        'is_confirm': 0,
        'is_cancel': 0,
        'subs': []
      },
      req_list: {
        'keyword': '',
        'page': 1,
        'limit': 10,
        'group_code': '',
        'branch_id': 0
      },
      bill_data: {
        'company_id': 1,
        'branch_id': 1,
        'id': 0,
        'doc_no': ''
      },
      branch: 0,
      modal_active: false,
      form_data: {},
      branch_detail: {}
    }
  },
  methods: {
    getListData () {
      if (this.req_list.branch_id === 0) {
        alert('กรุณาเลือกสาขา')
        return
      }
      this.$store.commit('Loading')
      apiST.reportItemBegin(sessionStorage.Url,
        this.header,
        this.req_list,
        result => {
          if (result.response === 'success') {
            this.bill_list = result.data
            this.len_list = result.len
          } else {
          }
          this.$store.commit('Loading')
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    pageSelect (val) {
      console.log(val)
      this.req_list.page = val
      this.getListData()
    },
    InspectByID (val) {
      this.$store.commit('Loading')
      let body = {
        'company_id': 1,
        'branch_id': 1,
        'id': parseInt(val)
      }
      apiST.getInspectByID(sessionStorage.Url,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.data_modal = result.data
            this.modal_active = true
          } else {
          }
          this.$store.commit('Loading')
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getGroupList () {
      apiItem.itemGroup(sessionStorage.Url,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.list_group = result.data
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    close_modal () {
      this.modal_active = false
      this.data_modal = {
        'id': 0,
        'company_id': 1,
        'branch_id': 0,
        'doc_no': '',
        'doc_date': moment(new Date()),
        'accept_date': '',
        'description': '',
        'accept_status': 0,
        'is_confirm': 0,
        'is_cancel': 0,
        'subs': []
      }
      this.req_list = {
        'company_id': 1,
        'branch_id': 1,
        'date': null,
        'keyword': ''
      }
      this.bill_data = {
        'company_id': 1,
        'branch_id': 1,
        'id': 0,
        'doc_no': ''
      }
    },
    printPDF () {
      if (this.req_list.branch_id === 0) {
        alert('กรุณาเลือกสาขา')
        return
      }
      this.$store.commit('Loading')
      apiST.reportItemBegin(sessionStorage.Url,
        this.header,
        {
          'keyword': this.req_list.keyword,
          'page': 1,
          'limit': 999999,
          'group_code': this.req_list.group_code,
          'branch_id': this.req_list.branch_id
        },
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data)
            this.branch_detail = JSON.stringify(result.branch)
            setTimeout(() => {
              this.$refs.printPDF.submit()
            }, 1000)
          }
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    printEXCEL () {
      if (this.req_list.branch_id === 0) {
        alert('กรุณาเลือกสาขา')
        return
      }
      this.$store.commit('Loading')
      apiST.reportItemBegin(sessionStorage.Url,
        this.header,
        {
          'keyword': this.req_list.keyword,
          'page': 1,
          'limit': 999999,
          'group_code': this.req_list.group_code,
          'branch_id': this.req_list.branch_id
        },
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data)
            console.log(this.form_data)
            setTimeout(() => {
              this.$refs.exportEXCEL.submit()
            }, 1000)
          }
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getBranch()
    this.getGroupList()
    // this.getListData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/stk_balance.js